module.exports = __webpack_public_path__ + "img/symbol_2.37d002f8.png";